import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { Role } from '@wavingroup/iot-core/gen/ts/wavin/ignite/v1/user_pb';
import {
  checkUserAuthAndTerms,
  doesUserHaveRequiredRole,
} from '~/shared/auth/auth-utils';
import { assertIsDefined } from '~/types/assert-type';
import { RoleModel } from '~/shared/models/role/RoleModel';
import { getDeviceQuery } from '~/shared/api/getDevice.queries';

export const devicePageLoader =
  (queryClient: QueryClient) =>
  async ({ params, request }: LoaderFunctionArgs) => {
    const { deviceId } = params;
    assertIsDefined(deviceId);

    await checkUserAuthAndTerms(queryClient, request);

    const hasConfigEditorRole = await doesUserHaveRequiredRole(
      queryClient,
      new RoleModel(Role.CONFIG_EDITOR),
    );

    return await queryClient.ensureQueryData(
      getDeviceQuery({ deviceId, includeSource: hasConfigEditorRole }),
    );
  };
